import {SuggestionPrimitive, useAuiState} from '@assistant-ui/react';
import {type AutoColor, CalloutIcon, type IconName} from '@wandb/components';
import React from 'react';

type WBAgentSuggestionItem = {
  icon: IconName;
  color: AutoColor;
  title: string;
  label: string;
  prompt: string;
};
export const SUGGESTION_ITEMS: WBAgentSuggestionItem[] = [
  {
    icon: 'lightboard',
    color: 'teal',
    title: 'Summarize project',
    label: 'Get a high-level overview of progress and results',
    prompt: 'Summarize this project',
  },
  {
    icon: 'magic-wand-star',
    color: 'blue',
    title: 'Recommend next experiment',
    label: 'Find the most promising next step',
    prompt: 'Recommend my next experiment',
  },
  {
    icon: 'dashboard-blackboard',
    color: 'magenta',
    title: 'What patterns do you see in my results?',
    label: 'Discover key trends and correlations',
    prompt: 'What patterns do you see in my results?',
  },
  {
    icon: 'report',
    color: 'gold',
    title: 'Write a report with visualizations',
    label: 'Create a report and charts for this project',
    prompt: 'Write a report with visualizations for this project',
  },
];

export const SuggestionItem = () => {
  const label = useAuiState(s => s.suggestion.label);
  const meta = SUGGESTION_ITEMS.find(i => i.label === label);
  if (!meta) {
    return null;
  }
  return (
    <SuggestionPrimitive.Trigger
      send
      className="flex px-16 py-12 w-full items-center gap-16 self-stretch rounded-lg border border-moon-250  hover:bg-moon-100 disabled:cursor-not-allowed disabled:opacity-50">
      <CalloutIcon icon={meta.icon} color={meta.color} size="sm" />
      <div className="flex flex-col gap-2 min-w-0 flex-1 text-left">
        <SuggestionPrimitive.Title className="text-moon-800 truncate font-semibold text-base leading-[22.4px]" />
        <SuggestionPrimitive.Description className="truncate text-moon-650 text-sm leading-[19.6px] font-normal" />
      </div>
    </SuggestionPrimitive.Trigger>
  );
};
